import { MutableRefObject, useState, useEffect, useCallback, Dispatch, SetStateAction } from 'react';
import _ from 'lodash';

export type ScrollableElement = Pick<HTMLDivElement, 'scrollTop'|'scrollHeight'|'clientHeight'|'addEventListener'|'removeEventListener'|'scroll'>

const useInfiniteScroll = (
  containerRef: MutableRefObject<ScrollableElement | null>,
  fetchItems: () => Promise<any>,
  triggerFetchPos = 300,
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.addEventListener('scroll', throttleOnScroll);
    }
    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener('scroll', throttleOnScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (isFetching) {
      const fetchingOff = () => setIsFetching(false);
      fetchItems().then(fetchingOff).catch(fetchingOff);
    }
  }, [isFetching]);

  const throttleOnScroll = useCallback(
    _.throttle(() => {
      const el = containerRef.current;
      if (!isFetching && el && el.scrollTop + el.clientHeight + triggerFetchPos >= el.scrollHeight) {
        setIsFetching(true);
      }
    }, 300),
    [],
  );

  return [isFetching, setIsFetching];
};

export default useInfiniteScroll;
